export const preConfiguredQuicklinks = {
  vrboUS: [
    {
      name: 'vrbo-home',
      title: 'Vrbo US Homepage',
      link: 'https://vrbo.com/',
      text: 'Find your dream vacation rental on Vrbo',
    },
    {
      name: 'vacation-rentals',
      title: 'Vacation rentals',
      link: 'https://www.vrbo.com/vacation-rentals',
      text: 'Search vacation rentals on Vrbo',
    },
    {
      name: 'staycations',
      title: 'Staycations (road trips)',
      link: 'https://www.vrbo.com/travel/staycation',
      text: 'Find a great road trip on Vrbo',
    },
    {
      name: 'florida',
      title: 'Florida',
      link: 'https://www.vrbo.com/vacation-rentals/usa/florida',
      text: 'Find Florida vacation rentals on Vrbo',
    },
    {
      name: 'destin',
      title: 'Destin',
      link: 'https://www.vrbo.com/vacation-rentals/usa/florida/north-west/destin',
      text: 'Find Destin vacation rentals on Vrbo',
    },
    {
      name: 'panama-city-beach',
      title: 'Panama City Beach',
      link: 'https://www.vrbo.com/vacation-rentals/usa/florida/north-west/panama-city-beach',
      text: 'Find Panama City Beach vacation rentals on Vrbo',
    },
    {
      name: 'gulf-shores',
      title: 'Gulf Shores',
      link: 'https://www.vrbo.com/vacation-rentals/usa/alabama/gulf-shores',
      text: 'Find Gulf Shores vacation rentals on Vrbo',
    },
    {
      name: 'hilton-head-island',
      title: 'Hilton Head Island',
      link: 'https://www.vrbo.com/vacation-rentals/usa/south-carolina/hilton-head-island',
      text: 'Find Hilton Head Island vacation rentals on Vrbo',
    },
    {
      name: 'gatlinburg',
      title: 'Gatlinburg',
      link: 'https://www.vrbo.com/vacation-rentals/usa/tennessee/east/gatlinburg',
      text: 'Find Gatlinburg vacation rentals on Vrbo',
    },
    {
      name: 'key-west',
      title: 'Key West',
      link: 'https://www.vrbo.com/vacation-rentals/usa/florida/keys/key-west-area/key-west',
      text: 'Find Key West vacation rentals on Vrbo',
    },
  ],
  vrboUK: [
    {
      name: 'vrbo-home',
      title: 'Vrbo UK Homepage',
      link: 'https://www.vrbo.com/en-gb/holiday-rentals/united-kingdom',
      text: 'Find your dream vacation rental on Vrbo',
    },
    {
      name: 'england',
      title: 'England',
      link: 'https://www.vrbo.com/en-gb/holiday-rentals/united-kingdom/england',
      text: 'Find England vacation rentals on Vrbo',
    },
    {
      name: 'spain',
      title: 'Spain',
      link: 'https://www.vrbo.com/en-gb/holiday-rentals/spain',
      text: 'Find Spain vacation rentals on Vrbo',
    },
    {
      name: 'scotland',
      title: 'Scotland',
      link: 'https://www.vrbo.com/en-gb/holiday-rentals/united-kingdom/scotland',
      text: 'Find Scotland vacation rentals on Vrbo',
    },
    {
      name: 'hot-tub-breaks',
      title: 'Hot tub breaks',
      link: 'https://www.vrbo.com/en-gb/travel/hot-tub-breaks',
      text: 'Find Hot tub breaks on Vrbo',
    },
    {
      name: 'cornwall',
      title: 'Cornwall',
      link: 'https://www.vrbo.com/en-gb/holiday-rentals/united-kingdom/england/cornwall',
      text: 'Find Cornwall vacation rentals on Vrbo',
    },
    {
      name: 'france',
      title: 'France',
      link: 'https://www.vrbo.com/en-gb/holiday-rentals/france',
      text: 'Find France vacation rentals on Vrbo',
    },
    {
      name: 'london',
      title: 'London',
      link: 'https://www.vrbo.com/en-gb/holiday-rentals/united-kingdom/england/greater-london/london',
      text: 'Find London vacation rentals on Vrbo',
    },
    {
      name: 'wales',
      title: 'Wales',
      link: 'https://www.vrbo.com/en-gb/holiday-rentals/united-kingdom/wales',
      text: 'Find Wales vacation rentals on Vrbo',
    },
    {
      name: 'florida',
      title: 'Florida',
      link: 'https://www.vrbo.com/en-gb/holiday-rentals/united-states/florida',
      text: 'Find Florida vacation rentals on Vrbo',
    },
  ],
};
